<template>
  <div ref="el" class="radar"></div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch, nextTick } from 'vue'
import * as echarts from 'echarts'

const props = defineProps({
  // [{ name, value }]，value 为 0-5 连续分
  data: { type: Array, default: () => [] },
  height: { type: Number, default: 320 }
})

const el = ref(null)
let chart = null
let ro = null

// 供父级在导出 PDF 前等待渲染完成，避免截到空白图
const rendered = ref(false)
defineExpose({ whenRendered })

function whenRendered () {
  return new Promise((resolve) => {
    if (rendered.value) return resolve()
    if (!chart) return resolve()
    chart.on('finished', () => {
      rendered.value = true
      resolve()
    })
    // 兜底：finished 事件在部分版本/场景下不触发
    setTimeout(() => {
      rendered.value = true
      resolve()
    }, 900)
  })
}

function option () {
  return {
    animation: true,
    animationDuration: 600,
    radar: {
      center: ['50%', '54%'],
      radius: '66%',
      min: 0,
      max: 5,
      splitNumber: 5,
      axisName: {
        color: '#4a4a52',
        fontSize: 12,
        formatter: (name) => {
          // 域名较长，按 4 字折行，避免标签溢出画布
          const per = 5
          let out = ''
          for (let i = 0; i < name.length; i += per) {
            out += (out ? '\n' : '') + name.slice(i, i + per)
          }
          return out
        }
      },
      splitLine: { lineStyle: { color: 'rgba(0,0,0,0.10)' } },
      splitArea: {
        areaStyle: { color: ['rgba(0,113,227,0.02)', 'rgba(0,113,227,0.05)'] }
      },
      axisLine: { lineStyle: { color: 'rgba(0,0,0,0.12)' } },
      indicator: props.data.map((d) => ({ name: d.name, max: 5 }))
    },
    series: [
      {
        type: 'radar',
        symbolSize: 5,
        lineStyle: { width: 2, color: '#0071e3' },
        itemStyle: { color: '#0071e3' },
        areaStyle: { color: 'rgba(0,113,227,0.18)' },
        data: [
          {
            value: props.data.map((d) => d.value),
            name: '能力域得分'
          }
        ]
      }
    ]
  }
}

function render () {
  if (!el.value) return
  if (!chart) chart = echarts.init(el.value)
  chart.setOption(option(), true)
  chart.resize()
}

onMounted(async () => {
  await nextTick()
  render()
  if (typeof ResizeObserver !== 'undefined') {
    ro = new ResizeObserver(() => chart && chart.resize())
    ro.observe(el.value)
  }
})

watch(() => props.data, render, { deep: true })

onBeforeUnmount(() => {
  if (ro) ro.disconnect()
  if (chart) {
    chart.dispose()
    chart = null
  }
})
</script>

<style scoped>
.radar {
  width: 100%;
  height: v-bind('height + "px"');
}
</style>
